/* unplugin-vue-components disabled */import script from "./MenuHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuHeader.vue?vue&type=script&setup=true&lang=js"

import "./MenuHeader.vue?vue&type=style&index=0&id=4b2c43d3&lang=scss"

const __exports__ = script;

export default __exports__